export class PrimaryKeyDescriptorEntry {
    constructor(primaryKey: string) {
        this.primaryKey = primaryKey;
    }
    public primaryKey: string;
}
